import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Button,
  Form,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Select from "react-select"
import classnames from "classnames"
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
// import "./datatables.scss"
import CustomTable from "components/Table/Table"

export const CandidateAdd = () => {
  // ------------------File Upload Dropzone Start-------------------
  const [selectedFiles, setselectedFiles] = useState([])

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  // ------------------File Upload Dropzone End-------------------
  // ------------------Form Repeater Start-------------------
  const [rows1, setrows1] = useState([])
  const [rows2, setrows2] = useState([])

  function handleAddRowNested() {
    const item1 = { name1: "" }
    setrows1([...rows1, item1])
  }

  function handleAddRowNested1() {
    const item2 = { name1: "" }
    setrows2([...rows2, item2])
  }
  // ------------------Form Repeater End-------------------

  // ------------------Multiple Select Start-------------------

  const [selectedEducationQualification, setselectedEducationQualification] =
    useState(null)

  function handleMulti(selectedEducationQualification) {
    setselectedEducationQualification(selectedEducationQualification)
  }

  const optionEducationQualification = [
    {
      label: "Picnic",
      options: [
        { label: "B.Tech", value: "B.Tech" },
        { label: "M.Tech", value: "M.Tech" },
        { label: "BCom", value: "BCom" },
      ],
    },
  ]
  // ------------------Multiple Select End-------------------

  const [mode, setMode] = useState(0)

  const [selectedGender, setselectedGender] = useState(null)
  function handleSelectGroup(selectedGender) {
    setselectedGender(selectedGender)
  }

  const [selectedMaritalStatus, setselectedMaritalStatus] = useState(null)
  function handleSelectGroup(selectedMaritalStatus) {
    setselectedMaritalStatus(selectedMaritalStatus)
  }

  const optionGender = [
    {
      options: [
        { label: "Male", value: "Male" },
        { label: "Female", value: "Female" },
      ],
    },
  ]

  const optionMaritalStatus = [
    {
      options: [
        { label: "Married", value: "Married" },
        { label: "Unmarried", value: "Unmarried" },
      ],
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add Candidate| Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Master"
              breadcrumbItem="Add Candidate"
            />
            <Col sm={6}></Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Card>
                    <CardBody className="pt-0">
                      <CardTitle className="h4 mb-4">Add Candidate</CardTitle>
                      <Row>
                        <Col lg={3}>
                          <Nav pills className="navtab-bg text-center">
                            <NavItem className="mb-3 w-100">
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className="active"
                                onClick={() => {
                                  // this.toggle1("5")
                                  setMode(1)
                                }}
                              >
                                Personal Details
                              </NavLink>
                            </NavItem>
                            <NavItem className="mb-3 w-100">
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className="active"
                                onClick={() => {
                                  setMode(2)
                                }}
                              >
                                Contact Details
                              </NavLink>
                            </NavItem>
                            <NavItem className="mb-3 w-100">
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className="active"
                                onClick={() => {
                                  setMode(3)
                                }}
                              >
                                Family Information
                              </NavLink>
                            </NavItem>
                            <NavItem className="mb-3 w-100">
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className="active"
                                onClick={() => {
                                  setMode(4)
                                }}
                              >
                                Education - Career
                              </NavLink>
                            </NavItem>
                            <NavItem className="mb-3 w-100">
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className="active"
                                onClick={() => {
                                  setMode(5)
                                }}
                              >
                                Partner Preferences
                              </NavLink>
                            </NavItem>
                            <NavItem className="mb-3 w-100">
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className="active"
                                onClick={() => {
                                  setMode(6)
                                }}
                              >
                                Photos
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </Col>

                        <Col lg={9}>
                          <TabContent
                            // activeTab={this.state.activeTab1}
                            className="p-3 pt-0 text-muted"
                          >
                            {mode == 1 ? (
                              <TabPane>
                                <Row>
                                  <Col sm="12">
                                    <AvForm className="needs-validation">
                                      <Row>
                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="FirstName"
                                              label="First Name"
                                              placeholder="First Name"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Last Name"
                                              name="LastName"
                                              placeholder="Last Name"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="BirthDate"
                                              label="Date of Birth"
                                              type="date"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="StoriesImage"
                                              label="Stories Image"
                                              placeholder="Stories Image"
                                              type="file"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="BirthPlace"
                                              label="Birth Place"
                                              placeholder="Birth Place"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Birth Time"
                                              name="BirthTime"
                                              placeholder="Birth Time"
                                              type="time"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col lg="4">
                                          <div className="mb-3">
                                            <Label>Gender</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col lg="4">
                                          <div className="mb-3">
                                            <Label>Marital Status</Label>
                                            <Select
                                              value={selectedMaritalStatus}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionMaritalStatus}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Height"
                                              name="Height"
                                              placeholder="Height"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Weight"
                                              name="Weight"
                                              placeholder="Weight"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Button
                                        color="primary"
                                        className="mt-3"
                                        type="submit"
                                      >
                                        Submit
                                      </Button>{" "}
                                      <Button
                                        color="outline-primary"
                                        className="mt-3"
                                        type="button"
                                      >
                                        Cancel
                                      </Button>
                                    </AvForm>
                                  </Col>
                                </Row>
                              </TabPane>
                            ) : (
                              ""
                            )}
                            {mode == 2 ? (
                              <TabPane>
                                <Row>
                                  <Col sm="12">
                                    <AvForm className="needs-validation">
                                      <Row>
                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="MobileNumber"
                                              label="Mobile Number"
                                              placeholder="MobileNumber"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Email Id"
                                              name="EmailId"
                                              placeholder="Email Id"
                                              type="email"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="Address"
                                              label="Address"
                                              type="textarea"
                                              className="form-control AddressTextarea"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Country</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>State</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>City</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Current Country</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Current City</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                      <Button
                                        color="primary"
                                        className="mt-3"
                                        type="submit"
                                      >
                                        Submit
                                      </Button>{" "}
                                      <Button
                                        color="outline-primary"
                                        className="mt-3"
                                        type="button"
                                      >
                                        Cancel
                                      </Button>
                                    </AvForm>
                                  </Col>
                                </Row>
                              </TabPane>
                            ) : (
                              ""
                            )}
                            {mode == 3 ? (
                              <TabPane>
                                <Row>
                                  <Col sm="12">
                                    <AvForm className="needs-validation">
                                      <Row>
                                        <Col md="6">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="FatherName"
                                              label="Father Name"
                                              placeholder="Father Name"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="6">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Father Occupation"
                                              name="FatherOccupation"
                                              placeholder="Father Occupation"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="6">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="MotherName"
                                              label="Mother Name"
                                              placeholder="Mother Name"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="6">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Mother Occupation"
                                              name="MotherOccupation"
                                              placeholder="Mother Occupation"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <hr
                                        style={{
                                          backgroundColor: "#000",
                                          color: "#000",
                                          opacity: 1,
                                        }}
                                      />
                                      <h5 className="mb-3 mt-2 text-dark">
                                        Sibling
                                      </h5>
                                      <hr
                                        style={{
                                          backgroundColor: "#000",
                                          color: "#000",
                                          opacity: 1,
                                        }}
                                      />
                                      <Form className="repeater">
                                        <div data-repeater-list="group-a">
                                          <div
                                            data-repeater-item
                                            className="row"
                                          >
                                            <div className="mb-3 col-lg-4">
                                              <FormGroup className="mb-3">
                                                <AvField
                                                  name="Name"
                                                  label="Name"
                                                  placeholder="Name"
                                                  type="text"
                                                  className="form-control"
                                                />
                                              </FormGroup>
                                            </div>

                                            <div className="mb-3 col-lg-3">
                                              <div className="mb-3">
                                                <Label>Gender</Label>
                                                <Select
                                                  value={selectedGender}
                                                  onChange={() => {
                                                    handleSelectGroup()
                                                  }}
                                                  options={optionGender}
                                                  classNamePrefix="select2-selection"
                                                />
                                              </div>
                                            </div>

                                            <div className="mb-3 col-lg-3">
                                              <div className="mb-3">
                                                <Label>Marital Status</Label>
                                                <Select
                                                  value={selectedMaritalStatus}
                                                  onChange={() => {
                                                    handleSelectGroup()
                                                  }}
                                                  options={optionMaritalStatus}
                                                  classNamePrefix="select2-selection"
                                                />
                                              </div>
                                            </div>

                                            <Col
                                              lg={2}
                                              className="align-self-center"
                                            >
                                              <div className="d-grid">
                                                <input
                                                  data-repeater-delete
                                                  type="button"
                                                  className="btn btn-primary"
                                                  value="Delete"
                                                />
                                              </div>
                                            </Col>
                                          </div>
                                        </div>

                                        {rows2.map((item2, idx) => (
                                          <React.Fragment key={idx}>
                                            <div
                                              data-repeater-list="group-a"
                                              id={"addr" + idx}
                                            >
                                              <div
                                                data-repeater-item
                                                className="row"
                                              >
                                                <div className="mb-3 col-lg-4">
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="Name"
                                                      label="Name"
                                                      placeholder="Name"
                                                      type="text"
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </div>

                                                <div className="mb-3 col-lg-3">
                                                  <div className="mb-3">
                                                    <Label>Gender</Label>
                                                    <Select
                                                      value={selectedGender}
                                                      onChange={() => {
                                                        handleSelectGroup()
                                                      }}
                                                      options={optionGender}
                                                      classNamePrefix="select2-selection"
                                                    />
                                                  </div>
                                                </div>

                                                <div className="mb-3 col-lg-3">
                                                  <div className="mb-3">
                                                    <Label>
                                                      Marital Status
                                                    </Label>
                                                    <Select
                                                      value={
                                                        selectedMaritalStatus
                                                      }
                                                      onChange={() => {
                                                        handleSelectGroup()
                                                      }}
                                                      options={
                                                        optionMaritalStatus
                                                      }
                                                      classNamePrefix="select2-selection"
                                                    />
                                                  </div>
                                                </div>

                                                <Col
                                                  lg={2}
                                                  className="align-self-center d-grid"
                                                >
                                                  <input
                                                    data-repeater-delete
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Delete"
                                                  />
                                                </Col>
                                              </div>
                                            </div>
                                          </React.Fragment>
                                        ))}
                                        <Button
                                          onClick={() => {
                                            handleAddRowNested1()
                                          }}
                                          color="success"
                                          className="btn btn-success mt-3 mt-lg-0"
                                        >
                                          Add
                                        </Button>
                                      </Form>
                                      <Button
                                        color="primary"
                                        className="mt-3"
                                        type="submit"
                                      >
                                        Submit
                                      </Button>{" "}
                                      <Button
                                        color="outline-primary"
                                        className="mt-3"
                                        type="button"
                                      >
                                        Cancel
                                      </Button>
                                    </AvForm>
                                  </Col>
                                </Row>
                              </TabPane>
                            ) : (
                              ""
                            )}
                            {mode == 4 ? (
                              <TabPane>
                                <Row>
                                  <Col sm="12">
                                    <AvForm className="needs-validation">
                                      <Row>
                                        <Col md="4">
                                          <div className="mb-3">
                                            <label className="control-label">
                                              Education Qualification
                                            </label>
                                            <Select
                                              value={
                                                selectedEducationQualification
                                              }
                                              isMulti={true}
                                              onChange={() => {
                                                handleMulti()
                                              }}
                                              options={
                                                optionEducationQualification
                                              }
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Qualification Remarks"
                                              name="QualificationRemarks"
                                              placeholder="Qualification Remarks"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Employee AS</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Area/Field</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              name="EmployeeWith"
                                              label="Employee With"
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Annual Income Range</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                      <Button
                                        color="primary"
                                        className="mt-3"
                                        type="submit"
                                      >
                                        Submit
                                      </Button>{" "}
                                      <Button
                                        color="outline-primary"
                                        className="mt-3"
                                        type="button"
                                      >
                                        Cancel
                                      </Button>
                                    </AvForm>
                                  </Col>
                                </Row>
                              </TabPane>
                            ) : (
                              ""
                            )}
                            {mode == 5 ? (
                              <TabPane>
                                <Row>
                                  <Col sm="12">
                                    <AvForm className="needs-validation">
                                      <Row>
                                        <Col md="4">
                                          <div className="mb-3 row">
                                            <Label>Age Between</Label>
                                            <div className="col">
                                              <Select
                                                value={selectedGender}
                                                onChange={() => {
                                                  handleSelectGroup()
                                                }}
                                                options={optionGender}
                                                classNamePrefix="select2-selection"
                                              />
                                            </div>
                                            <div className="col-md-1 pt-2 p-0 text-center ">
                                              To
                                            </div>
                                            <div className="col ">
                                              <Select
                                                value={selectedGender}
                                                onChange={() => {
                                                  handleSelectGroup()
                                                }}
                                                options={optionGender}
                                                classNamePrefix="select2-selection"
                                              />
                                            </div>
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Marital Status</Label>
                                            <Select
                                              value={selectedMaritalStatus}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionMaritalStatus}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3 row">
                                            <Label>Height Between</Label>
                                            <div className="col">
                                              <Select
                                                value={selectedGender}
                                                onChange={() => {
                                                  handleSelectGroup()
                                                }}
                                                options={optionGender}
                                                classNamePrefix="select2-selection"
                                              />
                                            </div>
                                            <div className="col-md-1 pt-2 p-0 text-center">
                                              To
                                            </div>
                                            <div className="col">
                                              <Select
                                                value={selectedGender}
                                                onChange={() => {
                                                  handleSelectGroup()
                                                }}
                                                options={optionGender}
                                                classNamePrefix="select2-selection"
                                              />
                                            </div>
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Manglik</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Country Living In</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Citizenship</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <label className="control-label">
                                              Education Qualification
                                            </label>
                                            <Select
                                              value={
                                                selectedEducationQualification
                                              }
                                              isMulti={true}
                                              onChange={() => {
                                                handleMulti()
                                              }}
                                              options={
                                                optionEducationQualification
                                              }
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <div className="mb-3">
                                            <Label>Annual Income Range</Label>
                                            <Select
                                              value={selectedGender}
                                              onChange={() => {
                                                handleSelectGroup()
                                              }}
                                              options={optionGender}
                                              classNamePrefix="select2-selection"
                                            />
                                          </div>
                                        </Col>

                                        <Col md="4">
                                          <FormGroup className="mb-3">
                                            <AvField
                                              label="Partner Description"
                                              name="PartnerDescription"
                                              placeholder="PartnerDescription"
                                              type="textarea"
                                              className="form-control AddressTextarea"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Button
                                        color="primary"
                                        className="mt-3"
                                        type="submit"
                                      >
                                        Submit
                                      </Button>{" "}
                                      <Button
                                        color="outline-primary"
                                        className="mt-3"
                                        type="button"
                                      >
                                        Cancel
                                      </Button>
                                    </AvForm>
                                  </Col>
                                </Row>
                              </TabPane>
                            ) : (
                              ""
                            )}
                            {mode == 6 ? (
                              <TabPane>
                                <Row>
                                  <Col sm="12">
                                    <AvForm className="needs-validation">
                                      <Row>
                                        <Dropzone
                                          onDrop={acceptedFiles => {
                                            handleAcceptedFiles(acceptedFiles)
                                          }}
                                        >
                                          {({
                                            getRootProps,
                                            getInputProps,
                                          }) => (
                                            <div className="dropzone">
                                              <div
                                                className="dz-message needsclick"
                                                {...getRootProps()}
                                              >
                                                <input {...getInputProps()} />
                                                <div className="mb-3">
                                                  <i className="mdi mdi-cloud-upload display-4 text-muted"></i>
                                                </div>
                                                <h4>
                                                  Profile here or click to
                                                  upload.
                                                </h4>
                                              </div>
                                            </div>
                                          )}
                                        </Dropzone>
                                        <div
                                          className="dropzone-previews mt-3 row"
                                          id="file-previews"
                                        >
                                          {selectedFiles.map((f, i) => {
                                            return (
                                              <Card
                                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                key={i + "-file"}
                                              >
                                                <div className="p-2">
                                                  <Row className="align-items-center">
                                                    <Col className="col-auto">
                                                      <img
                                                        data-dz-thumbnail=""
                                                        height="80"
                                                        className="avatar-sm rounded bg-light"
                                                        alt={f.name}
                                                        src={f.preview}
                                                      />
                                                    </Col>
                                                    <Col className="pl-5">
                                                      <Link
                                                        style={{
                                                          float: "right",
                                                          padding: "7px",
                                                          paddingRight: "0px",
                                                          paddingLeft: "12px",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          name="gender"
                                                        />
                                                      </Link>
                                                      <Link
                                                        style={{
                                                          float: "right",
                                                        }}
                                                      >
                                                        <i
                                                          className="mdi mdi-delete"
                                                          style={{
                                                            fontSize: "22px",
                                                            color: "red",
                                                          }}
                                                        ></i>
                                                      </Link>
                                                      <Link
                                                        to="#"
                                                        className="text-muted font-weight-bold"
                                                      >
                                                        {f.name}
                                                      </Link>
                                                      <p className="mb-0">
                                                        <strong>
                                                          {f.formattedSize}
                                                        </strong>
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </Card>
                                            )
                                          })}
                                        </div>
                                      </Row>
                                      <Button
                                        color="primary"
                                        className="mt-3"
                                        type="submit"
                                      >
                                        Submit
                                      </Button>{" "}
                                      <Button
                                        color="outline-primary"
                                        className="mt-3"
                                        type="button"
                                      >
                                        Cancel
                                      </Button>
                                    </AvForm>
                                  </Col>
                                </Row>
                              </TabPane>
                            ) : (
                              ""
                            )}
                          </TabContent>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
